const home = {
  'home.documentapproval': 'Approval Document',
  'home.qualitypolicy': 'Quality Policy',
  'home.bylaws': 'Details',
  'home.bulletinboard': 'Announcement',
  'home.documentdynamics': 'Document Updates',
  'home.seeall': 'See All',
};
export default home;
